import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { INCLUDED, PRICING, OFFER } from '../constants';
import { fmt, offerActive } from '../utils';
import { useCountdown, pad2 } from '../hooks/useCountdown';

const Intro = () => {
  const countdown = useCountdown();

  useGSAP(() => {
    gsap.to('.intro-in', { opacity: 1, y: 0, duration: 0.9, stagger: 0.1, ease: 'power3.out', delay: 0.1 });
  }, []);

  return (
    <section className="px-5 pb-6 pt-14 sm:px-10 sm:pt-20">
      <div className="screen-max-width">
        <span className="eyebrow intro-in translate-y-6 opacity-0">Website price calculator</span>
        <h1 className="intro-in mt-3 translate-y-6 text-4xl font-semibold tracking-tight text-ink opacity-0 sm:text-6xl">
          Your website. <span className="whitespace-nowrap"><span className="tabular">₹{fmt(PRICING.platforms.static.price)}.</span></span>
        </h1>
        <p className="intro-in mt-4 max-w-xl translate-y-6 text-lg text-gray opacity-0">
          Ready in 24 hours. Logo, content, domain and hosting included.
        </p>
        {countdown.active && (
          <a
            href="#platform"
            className="intro-in mt-8 inline-flex w-full translate-y-6 flex-col gap-5 rounded-3xl bg-ink px-6 py-5 text-white opacity-0 shadow-[0_20px_40px_-20px_rgba(0,0,0,0.45)] transition-transform hover:-translate-y-0.5 sm:w-auto sm:flex-row sm:items-center sm:gap-8 sm:px-7"
          >
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#30d158]">Your offer</p>
              <p className="text-xl font-semibold">WordPress upgrade free</p>
              <p className="text-sm text-white/60">
                Save ₹{fmt(PRICING.platforms.wp.price - PRICING.platforms.static.price)} · claim it before the timer runs out
              </p>
            </div>
            <div
              className="flex gap-2 text-2xl font-semibold text-white/40"
              aria-live="off"
              aria-label={`Offer ends in ${countdown.hours} hours ${countdown.minutes} minutes`}
            >
              <div className="flex flex-col items-center">
                <span className="tabular min-w-[64px] rounded-2xl bg-white/10 px-3 py-2 text-center text-white text-4xl font-semibold leading-none sm:text-5xl">
                  {pad2(countdown.hours)}
                </span>
                <span className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-white/50">hrs</span>
              </div>
              <span className="pt-3">:</span>
              <div className="flex flex-col items-center">
                <span className="tabular min-w-[64px] rounded-2xl bg-white/10 px-3 py-2 text-center text-white text-4xl font-semibold leading-none sm:text-5xl">
                  {pad2(countdown.minutes)}
                </span>
                <span className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-white/50">min</span>
              </div>
              <span className="pt-3">:</span>
              <div className="flex flex-col items-center">
                <span className="tabular min-w-[64px] rounded-2xl bg-white/10 px-3 py-2 text-center text-white text-4xl font-semibold leading-none sm:text-5xl">
                  {pad2(countdown.seconds)}
                </span>
                <span className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-white/50">sec</span>
              </div>
            </div>
          </a>
        )}
        <ul className="intro-in mt-8 flex max-w-3xl translate-y-6 flex-wrap gap-x-6 gap-y-2 opacity-0">
          {INCLUDED.map((item) => (
            <li key={item} className="flex items-center gap-2 text-sm text-ink">
              <span className="text-blue">✓</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Intro;
